var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('main-navigation',{attrs:{"animation":""}}),_c('div',{staticStyle:{"min-height":"400px"}},[_c('router-view')],1),_c('footer-navigation',{attrs:{"animation":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }